var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":_vm.width,"height":_vm.height,"viewBox":"0 0 320 512"}},[_c('g',{attrs:{"fill":_vm.color}},[_c('path',{attrs:{"xmlns":"http://www.w3.org/2000/svg","d":"M41 288h238c21.4 0 32.1 25.9 17 41L177 448c-9.4 9.4-24.6 9.4-33.9 0L24 329c-15.1-15.1-4.4-41 17-41z"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }